import { StyledRow } from "App/global-style";
import styled from "styled-components";

export const HeaderWrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  padding-bottom: 12px;
  width: 100%;

  @media screen and (min-width: 426px) {
    padding-left: "0px";
  }

  & label {
    font-size: 18px;

    /* font-weight: 700; */
    font-weight: 600;
  }
`;

export const PaymentHeaderWrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  padding-bottom: 12px;
  width: 100%;

  & label {
    font-size: 16px;
    font-weight: 600;
  }
`;

export const CoverageCardHeader = styled(StyledRow)`
  @media screen and (max-width: 768px) {
    align-items: flex-start;
    justify-content: flex-start;
  }
`;

export const InlineLabel = styled.label`
  align-items: "center";
  display: "flex";
  flex-flow: "row nowrap";
`;
